import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import Polyglot from "node-polyglot";
import * as s from "underscore.string";
export var Locales = /*#__PURE__*/ function() {
    "use strict";
    function Locales(options) {
        _class_call_check(this, Locales);
        this.p_locales = {};
        if (options) {
            if (options.defaultLocale) {
                this.locale = options.defaultLocale;
            }
            if (options.dictionaries) {
                this.setDictionaries(options.dictionaries);
            }
            this.fallbackLocales = options.fallbackLocales;
        }
    }
    var _proto = Locales.prototype;
    _proto.setDictionary = function setDictionary(dictionary) {
        var _this = this;
        this.p_locales[dictionary.locale] = new Polyglot({
            phrases: dictionary.translations,
            onMissingKey: function(key, options, locale) {
                if (dictionary.fallbackLocale && dictionary.fallbackLocale !== locale && _this.p_locales[dictionary.fallbackLocale]) {
                    return _this.p_format(key, dictionary.fallbackLocale, options);
                } else {
                    return key;
                }
            },
            locale: dictionary.locale
        });
        if (this.locale === undefined) {
            this.locale = dictionary.locale;
        }
    };
    _proto.setDictionaries = function setDictionaries(dictionaries) {
        var _this = this;
        dictionaries.forEach(function(dictionary) {
            return _this.setDictionary(dictionary);
        });
    };
    _proto.format = function format(key, options) {
        var locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.locale;
        return this.p_format(key, locale, options);
    };
    _proto.formatOrHumanize = function formatOrHumanize(key, options) {
        var locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.locale;
        var translation = this.p_format(key, locale, options);
        if (translation === key) {
            var ref;
            var toHumanize = typeof (options === null || options === void 0 ? void 0 : (ref = options.defaultTranslation) === null || ref === void 0 ? void 0 : ref.valueOf()) === "string" ? options.defaultTranslation : key;
            translation = s.humanize(toHumanize);
        }
        return translation;
    };
    _proto.formatOrDefault = function formatOrDefault(key, options) {
        var locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.locale;
        var translation = this.p_format(key, locale, options);
        if (translation === key) {
            var ref;
            translation = typeof (options === null || options === void 0 ? void 0 : (ref = options.defaultTranslation) === null || ref === void 0 ? void 0 : ref.valueOf()) === "string" ? options.defaultTranslation : key;
        }
        return translation;
    };
    _proto.p_format = function p_format(key, locale, options, secondTime) {
        if (this.p_locales[locale] === undefined) {
            throw 'The "'.concat(locale, '" language is not defined.');
        }
        var translation = options ? this.p_locales[locale].t(key, options) : this.p_locales[locale].t(key);
        if (!secondTime && Locales.p_isMissingKey(key, translation) && this.fallbackLocales) {
            translation = this.fallbackLocales.p_format(key, locale, options, true);
        }
        Locales.p_handleReportMissingKeyOption(key, translation, options, locale);
        return translation;
    };
    Locales.p_isMissingKey = function p_isMissingKey(key, translation) {
        return translation === key;
    };
    Locales.p_handleReportMissingKeyOption = function p_handleReportMissingKeyOption(key, translation, options, locale) {
        if (Locales.p_isMissingKey(key, translation) && (options === null || options === void 0 ? void 0 : options.reportMissingKey)) {
        // Disabling missing key errors as they spam the Sentry channel a lot
        // https://coveord.atlassian.net/browse/UITOOL-468
        // Localization.reportKeyNotFound(key, locale);
        }
    };
    return Locales;
}();

//# sourceMappingURL=Locales.js.map